import React from "react";
import SalesReturnTable from "./SalesReturnTable";

const index = () => {
  return (
    <div>
      <SalesReturnTable />
    </div>
  );
};

export default index;
